module.exports = __webpack_public_path__ + "static/media/colicoli02.bcbee6c2.webp";